import { InfoIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDeprecatedUserLevelCapacityLimits } from '../hooks/useUserLevelCapacityLimits';
import { useRealtimeUserLevelCapacityLimits } from '../hooks/useRealtimeUserLevelCapacityLimits';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCapacityLimitsTooltip = ({
  capacityLimit,
  capacityLoad
}) => {
  if (capacityLoad > capacityLimit) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimitsTooltip.overCapacity"
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimitsTooltip.atCapacity"
    });
  }
};
const getCapacityLimitsMessage = ({
  capacityLimit,
  capacityLoad
}) => {
  if (capacityLoad > capacityLimit) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimits.overCapacity",
      options: {
        ticketCount: capacityLoad,
        count: capacityLimit
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimits.atCapacity",
      options: {
        count: capacityLimit
      }
    });
  }
};
export const CapacityLimits = ({
  agentId
}) => {
  const {
    capacityLimits,
    loading: loadingCapacityLimits
  } = useDeprecatedUserLevelCapacityLimits(agentId);
  useRealtimeUserLevelCapacityLimits();
  if (loadingCapacityLimits || !capacityLimits || capacityLimits.capacityLimit > capacityLimits.capacityLoad) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: getCapacityLimitsTooltip(capacityLimits),
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginInline: "200",
        children: /*#__PURE__*/_jsx(InfoIcon, {
          color: "icon-core-subtle"
        })
      }), getCapacityLimitsMessage(capacityLimits)]
    })
  });
};
CapacityLimits.displayName = 'CapacityLimits';